import React, { useMemo } from 'react'
import InvestorCard from './InvestorCard'
import { computeMatchScore } from './InvestorCard'
import css from './style.scss'

const SORT_OPTIONS = [
  { value: 'matchScore', label: 'Sort by Match Score' },
  { value: 'activity', label: 'Sort by Activity' },
  { value: 'portfolio', label: 'Sort by Portfolio Size' },
  { value: 'avgPrice', label: 'Sort by Avg Price' },
]

export default function InvestorList({
  investors,
  selectedInvestorId,
  checkedInvestorIds = [],
  sortBy,
  loading,
  onSelectInvestor,
  onToggleChecked,
  onSort,
}) {
  // Compute fixed ranks based on match score (doesn't change with sort)
  const matchScoreRanks = useMemo(() => {
    if (!investors || investors.length === 0) return {}
    const sorted = [...investors].sort((a, b) => computeMatchScore(b) - computeMatchScore(a))
    const ranks = {}
    sorted.forEach((inv, i) => { ranks[inv.id] = i })
    return ranks
  }, [investors])

  if (loading) {
    return (
      <div className={css.listLoading}>
        <div className={css.spinner} />
        <div>Searching for cash buyers...</div>
      </div>
    )
  }

  if (!investors || investors.length === 0) {
    return (
      <div className={css.emptyState}>
        <div className={css.emptyIcon}>$</div>
        <div className={css.emptyTitle}>No investors yet</div>
        <div className={css.emptyText}>Enter a property address above to find cash buyers</div>
      </div>
    )
  }

  return (
    <div className={css.investorList}>
      <div className={css.listHeader}>
        <span className={css.listCount}>{investors.length} Ranked Investors</span>
        <select
          className={css.sortSelect}
          value={sortBy}
          onChange={(e) => onSort(e.target.value)}
        >
          {SORT_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>

      <div className={css.listScroll}>
        {investors.map((inv) => {
          const fixedRank = matchScoreRanks[inv.id] ?? investors.length
          const isChecked = checkedInvestorIds.includes(inv.id)
          const anyChecked = checkedInvestorIds.length > 0
          return (
            <InvestorCard
              key={inv.id}
              investor={inv}
              rank={fixedRank}
              selected={inv.id === selectedInvestorId}
              checked={isChecked}
              dimmed={anyChecked && !isChecked}
              onSelect={onSelectInvestor}
              onToggleChecked={onToggleChecked}
            />
          )
        })}
      </div>
    </div>
  )
}
